// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionE_TheComp__LFoui"};